import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";


import "./draftDetails.css";

export class DraftDetails extends React.Component {

  constructor(props) {
    super(props);

    this.draftInfo = this.props.schedule.PValue ? JSON.parse(this.props.schedule.PValue) : JSON.parse(this.props.schedule.Parameters)

    console.log(this.draftInfo)
  }

  getFollowupCondition = (action) => {

    switch (action) {
      case 'r':
        return 'Reply';

      case 'o':
        return 'Open';

      case 'c':
        return 'Click';

      case 'a':
        return 'Send All';

      case 's':
        return 'No Reply or Click';

      default:
        return 'NA'
    }

  }

  renderAutoFollowups = () => {
    let JSX = [];
    if (this.draftInfo.FirstBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage1'}>
        <div className="data-parameter">Followup Stage 1</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.FirstBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.FirstBumpSentCampaignID}`}> {`${this.props.campaign.FirstBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.FirstBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.FirstBumpTime ? this.draftInfo.FirstBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.FirstBumpCampaignID}{' '}
          | <b>Condition</b>: {this.getFollowupCondition(this.props.campaign.FirstBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT1}</div>
      </div>)
    }
    if (this.draftInfo.SecondBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage2'}>
        <div className="data-parameter">Followup Stage 2</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.SecondBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.SecondBumpSentCampaignID}`}> {`${this.props.campaign.SecondBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.SecondBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.SecondBumpTime ? this.draftInfo.SecondBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.SecondBumpCampaignID}{' '}
          | <b>Condition</b>: {this.getFollowupCondition(this.props.campaign.SecondBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT2}</div>
      </div>)
    }
    if (this.draftInfo.ThirdBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage3'}>
        <div className="data-parameter">Followup Stage 3</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.ThirdBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.ThirdBumpSentCampaignID}`}> {`${this.props.campaign.ThirdBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.ThirdBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.ThirdBumpTime ? this.draftInfo.ThirdBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.ThirdBumpCampaignID}{' '}
          | <b> Condition</b>: {this.getFollowupCondition(this.props.campaign.ThirdBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT3}</div>
      </div>)
    }

    if (this.draftInfo.FourthBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage4'}>
        <div className="data-parameter">Followup Stage 4</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.FourthBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.FourthBumpSentCampaignID}`}> {`${this.props.campaign.FourthBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.FourthBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.FourthBumpTime ? this.draftInfo.FourthBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.FourthBumpCampaignID}{' '}
          | <b> Condition</b>: {this.getFollowupCondition(this.props.campaign.FourthBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT4}</div>
      </div>)
    }

    if (this.draftInfo.FifthBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage5'}>
        <div className="data-parameter">Followup Stage 5</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.FifthBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.FifthBumpSentCampaignID}`}> {`${this.props.campaign.FifthBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.FifthBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.FifthBumpTime ? this.draftInfo.FifthBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.FifthBumpCampaignID}{' '}
          | <b> Condition</b>: {this.getFollowupCondition(this.props.campaign.FifthBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT5}</div>
      </div>)
    }


    if (this.draftInfo.SixthBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage6'}>
        <div className="data-parameter">Followup Stage 6</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.SixthBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.SixthBumpSentCampaignID}`}> {`${this.props.campaign.SixthBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.SixthBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.SixthBumpTime ? this.draftInfo.SixthBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.SixthBumpCampaignID}{' '}
          | <b> Condition</b>: {this.getFollowupCondition(this.props.campaign.SixthBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT6}</div>
      </div>)
    }


    if (this.draftInfo.SeventhBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage7'}>
        <div className="data-parameter">Followup Stage 7</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.SeventhBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.SeventhBumpSentCampaignID}`}> {`${this.props.campaign.SeventhBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.SeventhBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.SeventhBumpTime ? this.draftInfo.SeventhBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.SeventhBumpCampaignID}{' '}
          | <b> Condition</b>: {this.getFollowupCondition(this.props.campaign.SeventhBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT7}</div>
      </div>)
    }

    if (this.draftInfo.EighthBumpDays) {
      JSX.push(<div className="data-field-draft" key={'stage8'}>
        <div className="data-parameter">Followup Stage 8</div>
        <div className="data-value"><b>Campaign ID</b>: {this.props.campaign.EighthBumpSentCampaignID ? (<a target='_blank' rel="noopener noreferrer" href={`/campaign/${this.props.campaign.EighthBumpSentCampaignID}`}> {`${this.props.campaign.EighthBumpSentCampaignID}`}</a>) : 'Not Sent'}{' '}
          | <b>AfterDay</b>: {this.draftInfo.EighthBumpDays}{' '}
          | <b>Time</b>: {this.draftInfo.EighthBumpTime ? this.draftInfo.EighthBumpTime : 'NA'}{' '}
          | <b>RichTextCampaign</b>: {this.props.campaign.EighthBumpCampaignID}{' '}
          | <b> Condition</b>: {this.getFollowupCondition(this.props.campaign.EighthBumpAction)}{' '}
          | <b>AppendTo</b>: {this.draftInfo.BNOT8}</div>
      </div>)
    }


    return JSX
  }


  renderTriggers = () =>{
    let JSX = [];

    if(this.draftInfo.TriggerOpenCampaign){
    JSX.push(<div className="data-field-draft" key={'openTrigger'}>
        <div className="data-parameter">Open Trigger</div>
        <div className="data-value"><b>RichTextCampaign</b>: {this.draftInfo.TriggerOpenCampaign+" "}
          | <b>Send After</b>: {this.draftInfo.TriggerOpenDelayMinutes+" minutes "}
          | <b>AppendTo</b>: {this.draftInfo.TriggerOpenThread ? "Same Thread " : "New Thread "}</div>
      </div>)
    }

    if(this.draftInfo.TriggerClickCampaign){
      JSX.push(<div className="data-field-draft" key={'clickTrigger'}>
      <div className="data-parameter">Click Trigger</div>
      <div className="data-value"><b>RichTextCampaign</b>: {this.draftInfo.TriggerClickCampaign+" "}
        | <b>Send After</b>: {this.draftInfo.TriggerClickDelayMinutes+" minutes "}
        | <b>AppendTo</b>: {this.draftInfo.TriggerClickThread ? "Same Thread " : "New Thread "}</div>
    </div>)
    }
    
    if(this.draftInfo.TriggerReplyCampaign){
      JSX.push(<div className="data-field-draft" key={'clickTrigger'}>
      <div className="data-parameter">Reply Trigger</div>
      <div className="data-value"><b>RichTextCampaign</b>: {this.draftInfo.TriggerReplyCampaign+" "}
        | <b>Send After</b>: {this.draftInfo.TriggerReplyDelayMinutes+" minutes "}
        | <b>AppendTo</b>: {this.draftInfo.TriggerReplyThread ? "Same Thread " : "New Thread "}</div>
    </div>)
    }

    return JSX;
  }

  getDelayLength = () => {
    switch (parseInt(this.draftInfo.DelayLength)) {

      case 1:
        return "5 - 10 seconds";

      case 2:
        return "10 - 60 seconds";

      case 3:
        return "1 - 5 minutes";

      case 5:
        return "5 - 10 minutes"  ;
      default:
        return "NA";
    }
  }

  getDraftStage = (stage) => {

    switch (stage) {
      case 0:
        return "Pending Action"

      default:
        return "Action Taken"
    }


  }

  getAllowedDays = (allowedDays)=>{
    
    if(!allowedDays || allowedDays.length===0){
      return "Not Applied";
    }
    
    let days = allowedDays.split(',');
  
    for(let i=0; i<days.length;i++){

      if(days[i]===1){
        days[i] = "Sat";
      }

     if(days[i]===2){
         days[i] = "Sun";
     }
     
     if(days[i]===3){
         days[i] = "Mon";
     }
     
     if(days[i]===4){
         days[i] = "Tue";
     }
     
     if(days[i]===5){
         days[i] = "Wed";
     }
     
     if(days[i]===6){
         days[i] = "Thur";
     }
     
     if(days[i]===7){
         days[i] = "Fri";
     }
      if(i+1<days.length){
        days[i] = days[i]+ ", ";
      }
     
    }
    
    return days.join("");


  }

  toggleDraftModal = (event) => {
    event.stopPropagation();
    if (event.target.id === 'DraftDetails') {
      this.props.toggleDraftDetails()
    }

  }

  getRecurState = (recurValue) => {

    switch(recurValue){

      case "i":
        return "Hour | Instantly";

      case "d":
        return "Day";

      case "m":
        return "Month";

      case "h":
        return "Hour"

      default:
        
      return "No";

    }

  }

  render() {
    return ReactDOM.createPortal(
      <div className="DraftDetails" id="DraftDetails" onClick={this.toggleDraftModal}>
        <div className="DraftDetails-container">
          <div className="DraftDetails-heading"><b>DraftID</b>: {this.draftInfo.DraftId}</div>
          <div className="DraftDetails-wrapper">
            <div className="DraftDetails-ParameterSection-fulllength">
              <div className="DraftDetails-ParameterSection-title">Auto Followups & Triggers <span style={{ fontSize: '0.8em', marginLeft: '2%' }}><svg width="6" height="6" viewBox="0 0 6 6" className="state-logo"><circle cx="3" cy="13" r="3"
                fill={this.draftInfo.FirstBumpDays ? "#19B05F" : "#F27383"}
                fillRule="evenodd" transform="translate(0 -10)"></circle></svg>
                {this.draftInfo.FirstBumpDays ? ' Active' : ' InActive'}</span></div>
              <div className="DraftDetails-ParameterSection-spacer"></div>
              {this.draftInfo.Triggers ? (
                <div className="DraftDetails-ParameterSection-data">
                  {this.renderTriggers()}
                </div>) : ''
              }
              {this.draftInfo.FirstBumpDays ? (
                <div className="DraftDetails-ParameterSection-data">
                  {this.renderAutoFollowups()}
                </div>) : ''
              }
            </div>
            <div className="DraftDetails-ParameterSection">
              <div className="DraftDetails-ParameterSection-title">Schedule & Tracking</div>
              <div className="DraftDetails-ParameterSection-spacer"></div>
              <div className="DraftDetails-ParameterSection-data">

                <div className="data-field-draft">
                  <div className="data-parameter">Schedule Time</div>
                  <div className="data-value"><b>Start : </b>{this.draftInfo.FutureSendDateTime ? this.draftInfo.FutureSendDateTime : 'NA'}{' '}
                    | <b>End : </b>{this.draftInfo.EndTime ? this.draftInfo.EndTime : 'NA'}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Speed</div>
                  <div className="data-value"> <b>Emails/Day : </b>{this.draftInfo.SplitFactor ? this.draftInfo.SplitFactor : 'NA'}{' '}
                    | <b>Delay : </b>{!this.draftInfo.Delay ? 'NA' : this.getDelayLength()}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">MultiSend</div>
                  <div className="data-value">{this.draftInfo.MultiSend.length > 0 ? "true":"false"}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Repeat</div>
                  <div className="data-value">{this.getRecurState(this.draftInfo.Recur) === "No" ? 'NA' : `Every ${this.draftInfo.RecurEvery} ${this.getRecurState(this.draftInfo.Recur)}`}</div>
                </div>

                <div className="data-field-draft">
                  <div className="data-parameter">Open Tracking</div>
                  <div className="data-value"><span style={{ fontSize: '1em' }}><svg width="6" height="6" viewBox="0 0 6 6" className="state-logo"><circle cx="3" cy="13" r="3"
                    fill={this.draftInfo.OpenTracking ? "#19B05F" : "#F27383"}
                    fillRule="evenodd" transform="translate(0 -10)"></circle></svg>
                    {this.draftInfo.OpenTracking ? ' Active' : ' InActive'}</span></div>
                </div>


                <div className="data-field-draft">
                  <div className="data-parameter">Click Tracking</div>
                  <div className="data-value"><span style={{ fontSize: '1em' }}><svg width="6" height="6" viewBox="0 0 6 6" className="state-logo"><circle cx="3" cy="13" r="3"
                    fill={this.draftInfo.ClickTracking ? "#19B05F" : "#F27383"}
                    fillRule="evenodd" transform="translate(0 -10)"></circle></svg>
                    {this.draftInfo.ClickTracking ? ' Active' : ' InActive'}</span></div>
                </div>



              </div>
            </div>



            <div className="DraftDetails-ParameterSection" id="AdvanceChecks">
              <div className="DraftDetails-ParameterSection-title oddParam">Advance Checks</div>
              <div className="DraftDetails-ParameterSection-spacer"></div>
              <div className="DraftDetails-ParameterSection-data" >
                <div className="data-field-draft">
                  <div className="data-parameter">SkipHolidays</div>
                  <div className="data-value">{String(this.draftInfo.SkipHolidays)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Allowed Days</div>
                  <div className="data-value">{this.getAllowedDays(this.draftInfo.AllowedDays)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">SkipUnsubs</div>
                  <div className="data-value">{String(this.draftInfo.SkipUnsubs)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">SkipBounces</div>
                  <div className="data-value">{String(this.draftInfo.SkipBounces)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">SkipSent</div>
                  <div className="data-value">{String(this.draftInfo.SkipSent)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">VerifyEmailAddresses</div>
                  <div className="data-value">{String(this.draftInfo.Verify)}</div>
                </div>
              </div>
            </div>
            <div className="DraftDetails-ParameterSection">
              <div className="DraftDetails-ParameterSection-title">Action</div>
              <div className="DraftDetails-ParameterSection-spacer"></div>
              <div className="DraftDetails-ParameterSection-data">
                <div className="data-field-draft">
                  <div className="data-parameter">CreateDraft</div>
                  <div className="data-value">{String(this.draftInfo.SaveAsDraft)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Draft State</div>
                  <div className="data-value">{this.draftInfo.SaveAsDraft ? this.getDraftStage(this.props.schedule.JustDraftsState) : 'NA'}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">JustDraftsExecutionTime</div>
                  <div className="data-value">{this.props.schedule.JustDraftsSendTime}</div>
                </div>
              </div>
            </div>
            <div className="DraftDetails-ParameterSection">
              <div className="DraftDetails-ParameterSection-title oddParam">Suppressions</div>
              <div className="DraftDetails-ParameterSection-spacer"></div>
              <div className="DraftDetails-ParameterSection-data">
                <div className="data-field-draft suppression-draft">
                  <div className="data-parameter">Email Addresses / Domain</div>
                  <div className="data-value bump-suppression">{this.props.campaign.BumpSuppression}</div>
                </div>

                <div className="data-field-draft">
                  <div className="data-parameter">Campaign ID</div>
                  <div className="data-value">{this.draftInfo.Suppression}</div>
                </div>

                <div className="data-field-draft">
                  <div className="data-parameter">Suppression Days</div>
                  <div className="data-value">{this.draftInfo.SuppressionDays}</div>
                </div>
              </div>
            </div>
            <div className="DraftDetails-ParameterSection">
              <div className="DraftDetails-ParameterSection-title">Campaign Threads And Tests</div>
              <div className="DraftDetails-ParameterSection-spacer"></div>
              <div className="DraftDetails-ParameterSection-data">
              <div className="data-field-draft">
                  <div className="data-parameter">Send As Reply</div>
                  <div className="data-value">{String(this.draftInfo.AppendToThread)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">CampaignIDToReplyTo</div>
                  <div className="data-value">{parseInt(this.draftInfo.CampaignIDToReplyTo) ?  parseInt(this.draftInfo.CampaignIDToReplyTo) : 'NA'}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Seed Testing</div>
                  <div className="data-value">{String(this.draftInfo.SeedTest)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">SendTestSequence</div>
                  <div className="data-value">{String(this.draftInfo.SendTestSequence)}</div>
                </div>
              </div>
            </div>

            <div className="DraftDetails-ParameterSection">
              <div className="DraftDetails-ParameterSection-title oddParam">A/B Testing</div>
              <div className="DraftDetails-ParameterSection-spacer"></div>
              <div className="DraftDetails-ParameterSection-data">
              
                <div className="data-field-draft">
                  <div className="data-parameter">ABTest</div>
                  <div className="data-value">{String(this.draftInfo.ABTest)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Percentage of emails to send before making a decision</div>
                  <div className="data-value">{String(this.draftInfo.ABPercentage)}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Make a decision after</div>
                  <div className="data-value">{String(this.draftInfo.ABTimeAfter) + ' hour(s)'} {this.draftInfo.ABDecision === 'a' ? 'Automatically' : this.draftInfo.ABDecision === 'm' ? 'Manually' : 'NA'}</div>
                </div>
                <div className="data-field-draft">
                  <div className="data-parameter">Decision basedOn </div>
                  <div className="data-value">{this.draftInfo.ABDecision === 'a' ? this.getFollowupCondition(this.draftInfo.ABFactor) : 'NA'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
      document.querySelector("#modal")
    );
  }
}


const mapStateToProps = (state) => {
  return { schedule: state.campaign.cData.schedule, campaign: state.campaign.cData.campaign };
};

export default connect(mapStateToProps)(DraftDetails);
